export const useSeo = () => {
    function forPath(path: string) {
        // CALL API TO GET SEO TAGS
        // TODO: Call Dentsu API seo
        applySeoTags();
    }
    function forDentsuPath(path: string) {
        // CALL API TO GET SEO TAGS
        // TODO: Call Dentsu API seo
        applySeoTags();
    }
    function applySeoTags() {
        // TODO: Change metatags
    }

    return {
        forPath,
        forDentsuPath,
    };
};
